// extracted by mini-css-extract-plugin
export default {"eventsContainer":"CalendarWithEvents_eventsContainer__fO4ci"};